/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.error").
controller("DxErrorRouteController", function ErrorRouteController(
	$location,

	DX_URLS
) {
	"use strict";

	var self = this;

	self.Urls = DX_URLS;

	var params = $location.search();
	self.error = params.error_message;
	self.isSkolonError = false;

	if (self.error.includes("Skolon")) {
		self.isSkolonError = true;
	}
	self.requestId = params.request_id;
});
